function ZoomImage({ imgsrc, React, AppContext }) {
  let { ReactImageMagnify } = React.useContext(AppContext);

  const imgToDisplay  = imgsrc ? imgsrc : process.env.PUBLIC_URL + "/asset/images/image-not-found.png";
  const displayHeight = window.innerHeight - 150;
  
  return (
    <>
      <ReactImageMagnify {...{
        smallImage: {
            alt: '',
            isFluidWidth: false,
            src: imgToDisplay,
            width: 800,
            height: displayHeight //By default we can use 400
        },
        largeImage: {
            src: imgToDisplay,
            width: 1200,
            height: 1800
        },
        enlargedImagePosition: 'over'
      }} />

    </>
  )
}

export default ZoomImage